import { Link as RouterDomLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';

interface TestSidebarProps {
    tests: Array<string>,
    suites: Array<string>,
    setShowNewTest: React.Dispatch<React.SetStateAction<boolean>>,
    setShowNewSuite: React.Dispatch<React.SetStateAction<boolean>>
}

export const TestNavbar = (props: TestSidebarProps) => {
    const [anchorElTest, setAnchorElTest] = useState<null | HTMLElement>(null);
    const [anchorElSuite, setAnchorElSuite] = useState<null | HTMLElement>(null);
    const testListOpen = Boolean(anchorElTest);
    const suiteListOpen = Boolean(anchorElSuite);
    const handleOpenTestSubMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElTest(event.currentTarget);
    }

    const handleOpenSuiteSubMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElSuite(event.currentTarget);
    }

    const handleCloseTest = () => {
        setAnchorElTest(null);
    };

    const handleCloseSuite = () => {
        setAnchorElSuite(null);
    };
    return (
        <AppBar position="static" sx={{px: 0, height: 'fit-content'}}>
            <Container>
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'flex' } }}
                    >
                        Test Automation
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex' } }}>
                        <Button
                            aria-label="list of tests"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            aria-expanded={testListOpen ? 'true' : undefined}
                            onClick={handleOpenTestSubMenu}
                            color="inherit"
                        >
                            Tests
                        </Button>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElTest}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={testListOpen}
                            onClose={handleCloseTest}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {props.tests.map(test => (
                                <MenuItem key={test} onClick={handleCloseTest}>
                                    <Button component={RouterDomLink} to={`/test-automation/test-case/${test}`}>{test}</Button>
                                </MenuItem>
                            ))}
                            <Divider />
                            <MenuItem onClick={handleCloseTest}>
                                <ListItemButton onClick={() => props.setShowNewTest(true)}>
                                    <ListItemIcon>
                                        <AddIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Test'} />
                                </ListItemButton>
                            </MenuItem>
                        </Menu>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex' } }}>
                        <Button
                            aria-label="list of suites"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            aria-expanded={suiteListOpen ? 'true' : undefined}
                            onClick={handleOpenSuiteSubMenu}
                            color="inherit"
                        >
                            Suites
                        </Button>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElSuite}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={suiteListOpen}
                            onClose={handleCloseSuite}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {props.suites.map(suite => (
                                <MenuItem key={suite} onClick={handleCloseSuite}>
                                    <Button component={RouterDomLink} to={`/test-automation/suites/${suite}`}>{suite}</Button>
                                </MenuItem>
                            ))}
                            <Divider />
                            <MenuItem onClick={handleCloseSuite}>
                                <ListItemButton onClick={() => props.setShowNewSuite(true)}>
                                    <ListItemIcon>
                                        <AddIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Suite'} />
                                </ListItemButton>
                            </MenuItem>
                        </Menu>
                    </Box>
            </Toolbar>
        </Container >
    </AppBar >
    )
}